import { z } from 'zod';
/**
 * Geräte der Wirkia App (KON-232): Ein Handy, auf dem ein Benutzer die App angemeldet hat. Das Gerät meldet seine Kennung für Push-Nachrichten und bekommt dann bei neuen Chat-Nachrichten
 * eine Benachrichtigung. Die Nachricht enthält weder Namen noch Text, die App holt den Inhalt selbst vom Server.
 */
export const DEVICE_PLATFORMS = ['android', 'ios'];
/** Das Gerät meldet sich an. Meldet es sich noch einmal (zum Beispiel nach einer Neuinstallation der App), wird der alte Eintrag ersetzt. */
export const registerDeviceInput = z
    .object({
    /** Kennung des Geräts bei Google (FCM). Sie ändert sich, wenn die App neu installiert wird. */
    pushToken: z.string().trim().min(20, 'Die Kennung ist zu kurz').max(4096, 'Die Kennung ist zu lang'),
    platform: z.enum(DEVICE_PLATFORMS, 'Bitte Android oder iOS angeben'),
    deviceName: z.string().trim().max(100).optional(),
    appVersion: z.string().trim().max(30).optional(),
    chatPush: z.boolean().optional(),
})
    .strict();
export const updateDeviceInput = z.object({ chatPush: z.boolean('Bitte an oder aus angeben') }).strict();
//# sourceMappingURL=devices.js.map